function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true,\"minimize\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-9699352c\",\"scoped\":false,\"hasInlineConfig\":true}!postcss-loader?{\"sourceMap\":true,\"ident\":\"postcss\"}!sass-loader?{\"sourceMap\":true,\"includePaths\":[\"/Users/floor/Projects/repositories/kiempunt-infrastructure/tmp-deploy/resources/assets/sass\",\"/Users/floor/Projects/repositories/kiempunt-infrastructure/tmp-deploy/node_modules\"]}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SidebarTeacher.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[\"es2015\"],\"plugins\":[\"transform-object-rest-spread\"]}!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SidebarTeacher.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9699352c\",\"preserveWhitespace\":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SidebarTeacher.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/sidebar/SidebarTeacher.vue
// module id = h2O9
// module chunks = 1